import React from "react";

// locales
import i18n from '../../i18n';

// the hoc
import { withTranslation } from 'react-i18next';


class ToggleLanguage extends React.Component {

	constructor(props) {
		super(props);
		console.log('ING_Art_language: ' + window.ING_Art_language);
		console.log('ING_Art_dataUrl: ' + window.ING_Art_dataUrl);
		console.log('ING_Art_debugMode: ' + window.ING_Art_debugMode);
		this.changeLanguage(window.ING_Art_language);
	}

	changeLanguage(lng) {
		i18n.changeLanguage(lng);
	}

	render() {
		return (
			<div className="container-language-toggle">
				<p>{i18n.language}</p>

				<p>set vars in html document: ING_Art_language: "{window.ING_Art_language}" </p>
				<p>set vars in html document: ING_Art_dataUrl: "{window.ING_Art_dataUrl}" </p>
				<p>set vars in html document: ING_Art_debugMode: "{window.ING_Art_debugMode}" </p>

				<button type="button" className="btn btn-dark" onClick={() => this.changeLanguage('nl')}>nl</button>
				<button type="button" className="btn btn-dark" onClick={() => this.changeLanguage('fr')}>fr</button>
				{/* <button type="button" className="btn btn-dark" onClick={() => this.changeLanguage('de')}>de</button> */}
				<button type="button" className="btn btn-dark" onClick={() => this.changeLanguage('en')}>en</button>
				{/*
				<h1>{i18n.t('welcome.title', { framework: 'React' })}</h1>
				<h1>{i18n.t('Welcome to React')}</h1>
				*/}
			</div>
		);
	}
}

export default withTranslation()(ToggleLanguage);